'use strict';

jQuery(function($) {

    /**
     * Pandora Modal Class.
     *
     * Handles the opening and closing of modals using the `data-modle` attribute.
     * Adds/removes a body class when a modal is active.
     */
    class PandoraModal {

        /**
         * Constructor.
         * Sets the body class for open state and initializes event handlers.
         */
        constructor() {
            this.bodyClass = 'modal-open'; // Class added to <body> when modal is open.
            this.init();
        }

        /**
         * Initialize modal functionality.
         */
        init() {
            this.eventHandlers();
        }

        /**
         * Bind event handlers for opening and closing modals.
         */
        eventHandlers() {
            // Open modal on click of trigger element.
            $(document.body).on('click', '.model-toggle', this.openModal.bind(this));

            // Close modal on click of close button or element with data-dismiss="modal".
            $(document.body).on('click', '.min-model-close, [data-dismiss="modal"]', this.closeModal.bind(this));

            // Optional: close modal when clicking directly on modal overlay area.
            $(document).on('click', (e) => {
                if ($(e.target).hasClass('pandora-model-widget')) {
                    this.closeAllModals();
                }
            });
        }

        /**
         * Open the modal.
         *
         * @param {Event} e Event object.
         */
        openModal(e) {
            e.preventDefault();

            // Get the modal selector from the trigger element.
            let modalSelector = $(e.currentTarget).data('modle');
            let $modal = $(modalSelector);

            if ($modal.length) {
                this.closeAllModals(); // Ensure all other modals are closed first.
                $modal.addClass('active');
                $('body').addClass(this.bodyClass);
            }
        }

        /**
         * Close the modal.
         *
         * @param {Event} e Event object.
         */
        closeModal(e) {
            e.preventDefault();

            // Find the closest modal widget and remove active class.
            let $modal = $(e.currentTarget).closest('.pandora-model-widget');
            $modal.removeClass('active');
            $('body').removeClass(this.bodyClass);
        }

        /**
         * Close all active modals and remove body open state class.
         */
        closeAllModals() {
            $('.pandora-model-widget').removeClass('active');
            $('body').removeClass(this.bodyClass);
        }
    }

    // Initialize modal functionality.
    new PandoraModal();

});
